export default __webpack_public_path__ + "static/media/timelineUserCheck.b3bfefdd.svg";